import { Accordion, Box, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const FAQWrapper = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}) as typeof Box;

export const CustomAccordion = styled(Accordion)({
  borderRadius: '12px',
  backgroundColor: palette.background.blue500,
  boxShadow: 'none',
  border: 'none',

  '&.Mui-expanded': {
    margin: 0,
  },

  '.MuiButtonBase-root': {
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
  },

  '.MuiAccordionSummary-content': {
    margin: '18px 0',

    '&.Mui-expanded': {
      margin: '18px 0',
    },
  },

  '.MuiSvgIcon-root': {
    fill: palette.primary.purple500,
  },

  '.MuiAccordionDetails-root': {
    padding: '0 48px 20px 16px',
    textAlign: 'justify',
  },

  '&::before': {
    display: 'none',
  },

  '&:first-of-type': {
    borderRadius: '12px',
  },

  '&:last-of-type': {
    borderRadius: '12px',
  },
});

export const AccordionTitle = styled(Typography)({
  color: palette.text.header_unknown,
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20.48px',
  letterSpacing: '0%',
}) as typeof Typography;

export const AccordionDesc = styled(Typography)({
  color: palette.text.body,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '19.04px',
  letterSpacing: '0%',
}) as typeof Typography;
